/** 多页签状态（sessionStorage 持久化，布局层使用） */
const STORAGE_KEY = 'byyl_visited_tabs'
const HOME_TAB = { path: '/', title: '工作台', affix: true }

function loadVisited() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return [HOME_TAB]
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed) || !parsed.length) return [HOME_TAB]
    const rest = parsed.filter(function (t) { return t.path && t.path !== '/' })
    return [HOME_TAB].concat(rest)
  } catch (e) {
    return [HOME_TAB]
  }
}

let visited = loadVisited()

function persist() {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(visited))
}

export function getVisitedTabs() {
  return visited
}

export function addTabFromRoute(route) {
  if (!route.path || route.path === '/login') return
  const title = (route.meta && route.meta.title) || '未命名'
  if (visited.some(function (t) { return t.path === route.path })) return
  visited.push({
    path: route.path,
    title: title,
    affix: Boolean(route.meta && route.meta.affix)
  })
  persist()
}

export function removeTab(path) {
  const tab = visited.find(function (t) { return t.path === path })
  if (!tab || tab.affix) return false
  visited = visited.filter(function (t) { return t.path !== path })
  persist()
  return true
}

export function closeOtherTabs(keepPath) {
  visited = visited.filter(function (t) { return t.affix || t.path === keepPath })
  persist()
}

export function closeAllTabs() {
  visited = visited.filter(function (t) { return t.affix })
  persist()
}

export function resetTabs() {
  visited = [HOME_TAB]
  sessionStorage.removeItem(STORAGE_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/tabsStore.js